import React, { useState, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import { Controller } from 'react-hook-form';
import { c as classnames } from './index-2586sEvh.js';
import { R as RadioGroup } from './RadioGroup-ZDexyLRv.js';
import { R as RadioButton } from './RadioButton-iQCBhrqj.js';
import { useRouter } from 'next/router';

const Colors = ({ option, disabled, control, errors, onColorChange }) => {
    var _a;
    const { t: tValidation } = useTranslation('', { keyPrefix: '$common.$validation' });
    const { locale } = useRouter();
    const [selectedValueIndex, setSelectedValueIndex] = useState(null);
    const name = option.attribute_code;
    useEffect(() => {
        setSelectedValueIndex(null);
    }, [locale]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnChange = (e, onChange) => {
        const selectedValue = e.target.value;
        const selectedOption = option.values.find(opt => opt.label === selectedValue);
        if (selectedOption) {
            setSelectedValueIndex(selectedOption.value_index);
        }
        onChange(e);
        onColorChange(option.attribute_code, selectedValue);
    };
    const generateLabel = (optionValue, fieldValue) => {
        var _a;
        const { label } = optionValue;
        const backgroundColor = (_a = optionValue.swatch_data) === null || _a === void 0 ? void 0 : _a.value;
        const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(backgroundColor);
        const imageUrl = isImage
            ? `${process.env.NEXT_PUBLIC_GRAPHQL_API_URL.replace('/graphql', '')}/media/attribute/swatch/${backgroundColor}`
            : null;
        const colorClass = label.replace(/\s+/g, '-').toLowerCase();
        return (React.createElement("div", { style: {
                ...(imageUrl
                    ? {
                        backgroundImage: `url(${imageUrl})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }
                    : {}),
                ...(backgroundColor && !imageUrl ? { backgroundColor } : {}),
            }, className: classnames('product-colors-bg', colorClass, {
                active: fieldValue === label,
            }), title: label }));
    };
    const selectedLabel = (_a = option.values.find(opt => opt.value_index === selectedValueIndex)) === null || _a === void 0 ? void 0 : _a.label;
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: "product-colors-title" }, option.label),
        React.createElement("div", { className: "product-colors-container" },
            React.createElement(Controller, { control: control, name: name, render: ({ field: { onChange, value } }) => (React.createElement(RadioGroup, { name: name, errors: errors, ariaLabel: option.label },
                    !option.values.length && (React.createElement("div", { className: "product-colors-bg no-options", title: tValidation('noOptions') })),
                    option.values.map(optionValue => (React.createElement(RadioButton, { "data-event-name": "bloc_interact", "data-bloc-name": `${optionValue.label}`, key: optionValue.value_index, name: name, selectedValue: value, optionValue: optionValue.label, label: generateLabel(optionValue, value), disabled: disabled || optionValue.disabled, onChange: e => handleOnChange(e, onChange), inputClassName: "sr-only" }))),
                    selectedValueIndex !== null && (React.createElement("span", { className: "selected-label" }, selectedLabel)))) }))));
};

export { Colors as C };
//# sourceMappingURL=Colors-dSUpB4SX.js.map
